import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import {
  savePreviousState,
  validateChangeAtButton,
} from "../../../../../../../utils/EditChangeValidate";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setBreadCrumb } from "../../../../../../../store/userSlice";

export default function AddEditFormTermsAndCondition({
  submitForm,
  submitFormLoading,
  cancelForm,
  form = [],
  loadedValues,
  quotationNumber,
  currentQuotationId,
}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [prevState, setPrevState] = useState([]);
  const [allowEdit, setAllowEdit] = useState(!loadedValues);
  const { breadCrumbs } = useSelector((state) => state.user);
  const isCreateMode = location.pathname.includes("terms/create");
  const isEditMode = location.pathname.includes("terms/edit");

  useEffect(() => {
    if (isCreateMode) {
      dispatch(
        setBreadCrumb([
          ...breadCrumbs,
          {
            label: "CREATE",
            link: ``,
          },
        ])
      );
    } else if (isEditMode) {
      dispatch(
        setBreadCrumb([
          ...breadCrumbs,
          {
            label: "EDIT",
            link: ``,
          },
        ])
      );
    }
    return () => {
      const _breadCrumbs = [...breadCrumbs].filter(
        (bread) => bread.label !== "EDIT" && bread.label !== "CREATE"
      );
      // _breadCrumbs.pop();
      dispatch(setBreadCrumb([..._breadCrumbs]));
    };
  }, [quotationNumber, location.pathname, location.hash]);
  useEffect(() => {
    if (loadedValues) {
      setPrevState(savePreviousState(form));
    }
  }, []);

  useEffect(() => {
    if (prevState?.length > 0) {
      const valid = validateChangeAtButton(prevState, form);
      if (valid) setAllowEdit((p) => true);
      else setAllowEdit((p) => false);
    }
  }, [form]);

  return (
    <div className="flex justify-center textTransformNone items-center bg-white dark:bg-dark rounded-md py-5">
      <form
        method="POST"
        onSubmit={(event) => submitForm(event)}
        className="w-full !normal-case flex flex-col items-center justify-center"
      >
        {form.map((elem, index) => (
          <div key={index} className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-${elem.name}`} className="text-xs ">
              {elem.text}
            </label>
            {elem.type === "textarea" ? (
              <>
                <textarea
                  name={elem.name}
                  id={`addOrEdit-${elem.name}`}
                  required
                  placeholder={`Enter ${elem.text}`}
                  cols="30"
                  rows="10"
                  className="border-[1px] !normal-case border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  defaultValue={elem.value}
                  onChange={(e) => {
                    const errorElem = document.getElementById(
                      `termsAndCondition-${elem.columnName}`
                    );
                    errorElem.style.display = "none";
                    elem.update(e.target.value);
                  }}
                ></textarea>
                <p
                  id={`termsAndCondition-${elem.columnName}`}
                  className="hidden w-full h-5 bg-red/5 text-red text-xs"
                ></p>
              </>
            ) : elem.type === "select" ? (
              <>
                <select
                  defaultValue={elem.value}
                  className="select !normal-case select-sm select-bordered"
                  onChange={(e) => elem.update(e.target.value)}
                >
                  {elem.value === "" && (
                    <option value="" selected hidden>
                      Select a Status
                    </option>
                  )}
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </>
            ) : (
              <>
                <input
                  type={elem.type}
                  name={elem.name}
                  id={`addOrEdit-${elem.name}`}
                  placeholder={`Enter ${elem.text}`}
                  required
                  className="border-[1px] !normal-case  border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  defaultValue={elem.value}
                  onChange={(e) => {
                    const errorElem = document.getElementById(
                      `termsAndCondition-${elem.columnName}`
                    );
                    errorElem.style.display = "none";
                    elem.update(e.target.value);
                  }}
                  disabled={elem.disabled ? true : false}
                />

                <p
                  id={`termsAndCondition-${elem.columnName}`}
                  className="hidden w-full h-5 bg-red/5 text-red text-xs"
                ></p>
              </>
            )}
          </div>
        ))}

        <div className="p-2  w-full max-w-md flex gap-3">
          <button
            className="ring-1 uppercase ring-black dark:ring-red w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
            type="button"
            disabled={submitFormLoading}
            onClick={cancelForm}
          >
            <p>Cancel</p>
          </button>
          {allowEdit ? (
            <button
              className="bg-black uppercase dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              disabled={submitFormLoading}
            >
              <p>Submit</p>
              {submitFormLoading && <CgSpinner className="animate-spin" />}
            </button>
          ) : (
            <button
              disabled
              className="bg-gray uppercase cursor-not-allowed dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              title="no changes made"
            >
              <p>Submit</p>
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
